import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { first } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators,FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-set-own-password',
  templateUrl: './set-own-password.component.html',
  styleUrls: ['./set-own-password.component.scss']
})
export class SetOwnPasswordComponent implements OnInit {
  newPassword: string;
  oldPassword: string;
  error = '';
  loading = false;
  SetPassword: FormGroup;
  submitted: boolean=false;
  showerror: boolean;
  showerror1: boolean;
  showerror2: boolean;
  token: any;
  allowUser: boolean=false;
  rememberMeChecked1: boolean=false;
  show: boolean=false;
  type = "password";
  show1: boolean=false;
  type1 = "password";
  
  constructor(public auth:AuthenticationService,
    private formBuilder: FormBuilder,
    private router:Router,
    public route: ActivatedRoute,
    public user: UserService
    ) { 
      this.route.queryParams.subscribe((res) => {
        this.token=res.token;
      //  console.log(this.token)
      });
    }
    form: FormGroup;

  ngOnInit(): void {
      
    sessionStorage.clear();
    this.SetPassword = this.formBuilder.group({
      newPassword: ['', [Validators.required,Validators.pattern("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*+_=)/()/-]).{8,15}$") ]  ],
      // newPassword: ['', [Validators.required,Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$])(?=.{8,20})/)]],
      confirmPassword: ['', [Validators.required,Validators.pattern("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*+_=)/()/-]).{8,15}$") ]  ],
     });
     this.submitted = true;
     this.error="";
     this.verifyToken();
  }
  get f(){
    return this.SetPassword.controls;
}
test(){
    
  this.showerror=false
  this.showerror1=false
  this.showerror2=false
  this.error="";
      //  if(this.SetPassword.invalid){
        // if(this.f.newPassword.value!=this.f.confirmPassword.value){
        //   this.error="“New Password” and “Confirm Password” do not match.​";
        // }
        // else{
        //   this.showerror2=true;
        // }
        if(this.f.newPassword?.errors!==null)
          {
            this.error="Password is required";
            this.showerror=true
          }
          else{
            this.showerror=false;
          }
          if(this.f.confirmPassword?.errors!==null)
          {
            this.showerror1=true;
          }
          else{
            this.showerror1=false;
          }
        // if(this.f.newPassword.value!=this.f.confirmPassword.value){
        //   this.error="“New Password” and “Confirm Password” do not match.​";
        // }
      // }
    
}
onSubmit(){
  //debugger
    this.submitted = true;
    // this.error="";
// stop if form is invalid
    // if(this.SetPassword.invalid){
    //   if(this.f.newPassword.errors.required)
    //   {
    //     this.error="Please check the password format!";
    //   }
    //   else{
    //     this.showerror=true;
    //   }
    //   if(this.f.confirmPassword.errors.required)
    //   {

    //   }
    //   else{
    //     this.showerror1=true;
    //   }
    // }
      
    if(this.allowUser == true){
  if(this.f.newPassword.value!=this.f.confirmPassword.value){
        this.error="“New Password” and “Confirm Password” do not match.​";
      }
      if(this.showerror==false && this.showerror1==false&& this.error==""){
        this.error="";
        this.loading = true;
        this.auth.setPassword(this.f.newPassword.value, this.f.confirmPassword.value,this.token)
        .pipe(first())
        .subscribe(
            data => {
              //debugger
              //console.log(data)
             // this.router.navigateByUrl('/login')
             sessionStorage.setItem('loginURLAttempted', 'true');
             localStorage.setItem('currentToken', JSON.stringify(data?.accessToken));
             sessionStorage.setItem("leadEmailInfo", JSON.stringify(data.userProfile.email))
             this.getDashboard() 
            //  if(data.firstTime){
            //  this.router.navigateByUrl('/home/steps-status')
            //  Swal.fire('','Password created successfully.','success')
            //  }
            //  else{
            //   this.getDashboard();
            //   sessionStorage.setItem("leadEmailInfo", JSON.stringify(data.userProfile.email))
            //   this.router.navigate(['/activated']);
            //  }
              
            },error=>{
              //  if(this.baseservice.handleError(error)){
                 //handle Exception from Server 404,401
                if(error.status == 400 || error.status==417){
                    this.error=error.error.data;
                    this.loading = false;
                 }
                 else{
                    this.loading = false;
             

                   this.error="Something went wrong. Please refresh the page and try again.";
                 }
             //  }
                },()=>{});
      }
    }
      else{
        Swal.fire("Please review the 'Travelance Privacy Policy' and click the checkbox to continue.")
      }
      }
onSelected(data){
    
    var checkFlag = data.target.checked;
    if(checkFlag == true){
      this.allowUser = true;
   
    }
    else{
      this.allowUser = false;
    }
  }
  toggleShow() {
    this.show = !this.show;
    if (this.show) {
      this.type = "text";
    }
    else {
      this.type = "password";
    }
  }
  toggleShow1() {
    this.show1 = !this.show1;
    if (this.show1) {
      this.type1 = "text";
    }
    else {
      this.type1 = "password";
    }
  }
  dashboardList: any=[];
  // getDashboard() {
  //   this.user.getDashboardData().pipe()
  //     .subscribe(
  //       data => {
  //         if(data.data.leads.leadId!=null){
  //           sessionStorage.setItem('leadId',data.data.leads.leadId)
  //         }
  //         if(data.data.leads.agencyId!=null){
  //           sessionStorage.setItem('agencyId',data.data.leads.agencyId)
  //         }
  //         if(data.data.leads.type!=null){
  //           sessionStorage.setItem('leadtype',data.data.leads.type)
  //         }
  //         if(data.data.leads.leadStatus!=null){
  //           sessionStorage.setItem('leadStatus',data.data.leads.leadStatus)
  //         }
  //         if(data.data.leads.stagesViews!=null){
  //           sessionStorage.setItem('stagesViews', JSON.stringify(data.data.leads.stagesViews))
  //         }
  //       }, error => {
  
  //         if (error.status == 400 || error.status == 417) {
  //           this.error = error.error.data;
  //         }
  //         else {
  //           this.error = "Something went wrong. Please refresh the browser and try again.";
  //         }
  //       }, () => { });
  // }
  getDashboard() {
    //debugger
    this.user.getDashboardData().pipe()
      .subscribe(
        data => {
          //debugger
           this.dashboardList = data.data;
           sessionStorage.setItem('leadId',data.data.leads.leadId)
           sessionStorage.setItem('agencyId',data.data.leads.agencyId)
           sessionStorage.setItem('leadtype',this.dashboardList.leads.type)
           sessionStorage.setItem('leadStatus',this.dashboardList.leads.leadStatus)
  
           sessionStorage.setItem('stagesViews', JSON.stringify(this.dashboardList.leads.stagesViews))
          //  this.dashboardList.leads.type=="MGA Admin" &&
           if(this.dashboardList.leads.stagesViews[0].isCompleted === true &&
               this.dashboardList.leads.stagesViews[0].isApproved === true   &&
            this.dashboardList.leads.stagesViews[1].isCompleted === true &&
               this.dashboardList.leads.stagesViews[1].isApproved === true   &&
            this.dashboardList.leads.stagesViews[2].isCompleted === true &&
               this.dashboardList.leads.stagesViews[2].isApproved === true   &&
           this.dashboardList.leads.stagesViews[3].isCompleted === true &&
               this.dashboardList.leads.stagesViews[3].isApproved === true)
               {
                  if(data.data.leads.leadId!=null){
                    sessionStorage.setItem('leadId',data.data.leads.leadId)
                  }
                  if(data.data.leads.agencyId!=null){
                    sessionStorage.setItem('agencyId',data.data.leads.agencyId)
                  }
                  if(data.data.leads.type!=null){
                    sessionStorage.setItem('leadtype',data.data.leads.type)
                  }
                  if(data.data.leads.leadStatus!=null){
                    sessionStorage.setItem('leadStatus',data.data.leads.leadStatus)
                  }
                  if(data.data.leads.stagesViews!=null){
                    sessionStorage.setItem('stagesViews', JSON.stringify(data.data.leads.stagesViews))
                  }
                this.router.navigate(['/activated']);
                Swal.fire('','Password created successfully.','success')
              }
          else{
            this.router.navigateByUrl('/home/steps-status')
             Swal.fire('','Password created successfully.','success')
  //          if (this.dashboardList.leads.stagesViews[0].isCompleted === true && this.dashboardList.leads.stagesViews[0].isApproved === false) {
  //           this.router.navigate(['/dashboard/personal-info']);
  //         }
  // else if (this.dashboardList.leads.stagesViews[1].isCompleted === true && this.dashboardList.leads.stagesViews[1].isApproved === false) {
  // this.router.navigate(['/dashboard/upload-documents']);
  //         }
  //         else if (this.dashboardList.leads.stagesViews[2].isCompleted === true && this.dashboardList.leads.stagesViews[2].isApproved === false) {
  // this.router.navigate(['/dashboard/contract-sign']);
  //         }
  //         else if (this.dashboardList.leads.stagesViews[3].isCompleted === true && this.dashboardList.leads.stagesViews[3].isApproved === false) {
  // this.router.navigate(['/dashboard/online-training']);
  //         }
  // else{
  //   this.router.navigate(['/dashboard/personal-info']);
  // }
  }
        }, error => {
  
          if (error.status == 400 || error.status == 417) {
            this.error = error.error.data;
          }
          else {
            this.error = "Something went wrong. Please refresh the browser and try again.";
          }
        }, () => { });
  }
  verifyToken(){
    this.user.verifyToken(this.token,false,true).pipe()
    .subscribe(
      data => {
        if(data.data=="false"){
        }else{
          this.router.navigateByUrl('/login')
        }
      }, error => {
      }, () => { });
  }
}
